const TermsPage = () => (
  <div className="mx-auto max-w-2xl space-y-6" data-testid="terms-page">
    <h2 className="text-2xl font-semibold" data-testid="terms-title">
      TERMS OF USE (YOPINION)
    </h2>
    <div className="space-y-6 text-sm leading-relaxed text-muted-foreground" data-testid="terms-content">
      <p>Effective Date: Last updated: May 2026</p>
      <p>By using Yopinion, you agree to these terms.</p>

      <div>
        <p className="font-medium text-foreground">1. Platform Overview</p>
        <p className="mt-1">Yopinion is a platform where users:</p>
        <ul className="mt-1 list-disc pl-5 space-y-1">
          <li>Create polls</li>
          <li>Vote on questions</li>
          <li>View aggregated opinions</li>
        </ul>
      </div>

      <div>
        <p className="font-medium text-foreground">2. User Responsibility</p>
        <p className="mt-1">You agree to:</p>
        <ul className="mt-1 list-disc pl-5 space-y-1">
          <li>Provide accurate information</li>
          <li>Use the platform responsibly</li>
          <li>Not misuse or harm others</li>
        </ul>
      </div>

      <div>
        <p className="font-medium text-foreground">3. Prohibited Content</p>
        <p className="mt-1">You must NOT post:</p>
        <ul className="mt-1 list-disc pl-5 space-y-1">
          <li>Illegal or harmful content</li>
          <li>Hate speech or harassment</li>
          <li>Explicit or abusive material</li>
          <li>Misleading or spam content</li>
        </ul>
        <p className="mt-1">We reserve the right to remove content.</p>
      </div>

      <div>
        <p className="font-medium text-foreground">4. Content Ownership</p>
        <ul className="mt-1 list-disc pl-5 space-y-1">
          <li>You own the content you create</li>
          <li>You grant Yopinion a license to display and use it</li>
          <li>Poll results may be used for insights and analytics</li>
        </ul>
      </div>

      <div>
        <p className="font-medium text-foreground">5. Platform Availability</p>
        <p className="mt-1">We may:</p>
        <ul className="mt-1 list-disc pl-5 space-y-1">
          <li>Modify features</li>
          <li>Pause or discontinue services</li>
          <li>Update the platform at any time</li>
        </ul>
      </div>

      <div>
        <p className="font-medium text-foreground">6. No Guarantee of Accuracy</p>
        <p className="mt-1">Yopinion reflects public opinion, not facts.</p>
        <p className="mt-1">We do not guarantee:</p>
        <ul className="mt-1 list-disc pl-5 space-y-1">
          <li>accuracy</li>
          <li>correctness</li>
          <li>reliability of poll results</li>
        </ul>
      </div>

      <div>
        <p className="font-medium text-foreground">7. Limitation of Liability</p>
        <p className="mt-1">Yopinion is not responsible for:</p>
        <ul className="mt-1 list-disc pl-5 space-y-1">
          <li>decisions made based on poll results</li>
          <li>user-generated content</li>
          <li>any indirect damages</li>
        </ul>
      </div>

      <div>
        <p className="font-medium text-foreground">8. Account Termination</p>
        <p className="mt-1">We may suspend or remove accounts for violations.</p>
      </div>

      <div>
        <p className="font-medium text-foreground">9. Changes to Terms</p>
        <p className="mt-1">We may update terms at any time. Continued use = acceptance.</p>
      </div>

      <div>
        <p className="font-medium text-foreground">10. Governing Law</p>
        <p className="mt-1">These terms are governed by the laws of India.</p>
      </div>
    </div>
  </div>
);

export default TermsPage;
